const NGN_FORMATTER = new Intl.NumberFormat('en-NG', {
  style: 'currency',
  currency: 'NGN',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Formats a decimal money string as Nigerian Naira. */
export function formatNgn(amount: string | null | undefined): string {
  if (amount === null || amount === undefined || amount === '') {
    return '—';
  }

  const parsed = Number.parseFloat(amount);

  if (Number.isNaN(parsed)) {
    return amount;
  }

  return NGN_FORMATTER.format(parsed);
}
